import React from "react";
import Select, { selectComponents } from "../../../common/select.jsx";

function ContentTypeFilter({ contentTypes, contentType, onChange, multiSelect = false }) {
  return (
    <Select
      value={multiSelect ? contentType : contentType[0]}
      placeholder={"Type"}
      name={"provider"}
      options={contentTypes}
      onChange={(input) => onChange(input)}
      containerClass="react-select-container--light react-select-container--small"
      isMulti={multiSelect}
      components={{
        ClearIndicator: () => null,
        MultiValueRemove: (props) =>
          props.selectProps.value.length > 1 ? <selectComponents.MultiValueRemove {...props} /> : null, // removes x when only one item
      }}
    />
  );
}

export default ContentTypeFilter;
